<div>
  <div class="link-data-container">
    <div *ngIf="aidaEligibility$ | async" class="aida-box mt-2 mb-4">
      <!-- left side -->
      <div class="aida-info">
        <div class="aida-info-container">
          <div class="aida-info">
            <img
              class="aida-icon"
              src="./../../../../assets/image/blue-stars.svg"
              alt="Blue stars icon"
            />
            <h5 class="aida-title">
              <span class="fw-bold"> AIDA&#8482; </span> (AI Delivery Assistant)
              Activated.
            </h5>
            <ps-ui-aida-info-tooltip></ps-ui-aida-info-tooltip>
          </div>
          <p class="aida-subtitle ms-2">
            Let our AI handle your project fielding.
          </p>
        </div>
      </div>
    </div>
    <table
      class="table survey-detail-table"
      aria-label="Link/Other Details"
      aria-hidden="true"
    >
      <tbody>
        <!-- Survey ID -->
        <tr>
          <td>Survey ID</td>
          <td>{{ surveyId }}</td>
        </tr>
        <!-- Country -->
        <tr>
          <td>Country</td>
          <td>
            {{
              selectedSvpChildSurvey
                ? selectedSvpChildSurvey.countryName
                : survey.countryName
            }}
          </td>
        </tr>
        <!-- Language -->
        <tr>
          <td>Language</td>
          <td>
            {{
              selectedSvpChildSurvey
                ? selectedSvpChildSurvey.languageName
                : survey.languageName
            }}
          </td>
        </tr>
        <!-- Field Date Info -->
        <ng-container *ngIf="survey.field_date_info">
          <tr>
            <td>Field Date Info</td>
            <td>
              <strong>Start Date -</strong>
              {{
                (survey.field_date_info.creation_date | date : 'yyyy/MM/dd') ||
                  'NA'
              }},&nbsp;
              <strong>End Date -</strong>
              {{
                (survey.field_date_info.end_date | date : 'yyyy/MM/dd') || 'NA'
              }},&nbsp;
              <strong>Days in field -</strong>
              {{ survey.field_date_info.days_in_field }},&nbsp;
              <strong> Days Remaining -</strong>
              {{ survey.field_date_info.days_remaining }}
            </td>
          </tr>
        </ng-container>
        <!-- Survey Open/Close Date Info - Operator/Buyer -->
        <tr
          *ngIf="
            survey.survey_open_close_date_info &&
            survey.survey_open_close_date_info.survey_launch
          "
        >
          <td>Survey Open/Close Date Info</td>
          <td>
            <strong>Launch Date - </strong>
            {{
              (survey.survey_open_close_date_info.survey_launch
                | date : 'YYYY/MM/dd HH:mm:ss') || 'NA'
            }},&nbsp;
            <strong> Close Date - </strong>
            {{
              (survey.survey_open_close_date_info.survey_close
                | date : 'YYYY/MM/dd HH:mm:ss') || 'NA'
            }},&nbsp;
            <ng-container
              *ngIf="
                survey.survey_open_close_date_info &&
                survey.survey_open_close_date_info.open_dates
              "
            >
              <strong> Days - </strong>
              {{ survey.survey_open_close_date_info?.open_dates?.d }},&nbsp;
              <strong> Hours - </strong>
              {{ survey.survey_open_close_date_info?.open_dates?.h }},&nbsp;
              <strong> Minutes - </strong>
              {{ survey.survey_open_close_date_info?.open_dates?.m }},&nbsp;
              <strong> Total Minutes - </strong>
              {{ survey.survey_open_close_date_info?.open_dates?.tm }}
            </ng-container>
          </td>
        </tr>
        <!-- Survey Open/Close Date Info - Supplier  -->
        <tr *ngIf="survey.sr_launch_ts">
          <td>Survey Open/Close Date Info</td>
          <td>
            <strong>Launch Date -</strong>
            {{
              (survey.sr_launch_ts | date : 'yyyy/MM/dd HH:mm:ss') || 'NA'
            }},&nbsp;
            <strong> Close Date -</strong>
            {{
              (survey.sr_close_ts | date : 'yyyy/MM/dd HH:mm:ss') || 'NA'
            }},&nbsp;
            <ng-container *ngIf="survey.open_dates">
              <strong> Days -</strong>
              {{ survey.open_dates.d }},&nbsp;
              <strong> Hours -</strong>
              {{ survey.open_dates.h }},&nbsp;
              <strong> Minutes -</strong>
              {{ survey.open_dates.m }},&nbsp;
              <strong> Total Minutes -</strong>
              {{ survey.open_dates.tm }}
            </ng-container>
          </td>
        </tr>
        <!-- User Name - Operator/Buyer -->
        <ng-container *ngIf="survey.buyer_name">
          <tr>
            <td>User Name</td>
            <td>{{ survey.buyer_name }}</td>
          </tr>
        </ng-container>
        <!-- User Email - Operator/Buyer -->
        <ng-container *ngIf="survey.buyer_email">
          <tr>
            <td>User Email</td>
            <td>{{ survey.buyer_email }}</td>
          </tr>
        </ng-container>
        <!-- Survey Category -->
        <tr>
          <td>Survey Category</td>
          <td>{{ survey.samples_name }}</td>
        </tr>
        <!-- Category Exclusion -->
        <tr>
          <td>Category Exclusion</td>
          <td>&nbsp;</td>
        </tr>
        <!-- Include/Exclude -->
        <tr>
          <td>Include/Exclude</td>
          <td *ngIf="survey.incl_excl === 0">Exclude</td>
          <td *ngIf="survey.incl_excl === 1">Include</td>
        </tr>
        <!-- Survey Exclusion -->
        <ng-container>
          <tr>
            <td>Survey Exclusion</td>
            <!-- Operator/Buyer -->
            <ng-container *psUiHasRole="['buyer', 'operator']">
              <ng-container *ngIf="survey.mc?.SVP; else nonSvpBuyerSurvey">
                <td>
                  <ps-ui-multi-locale-field-label
                    [selectedSvpChildSurvey]="selectedSvpChildSurvey"
                    field="survey_grouping"
                    [mcSvpChildSurveys]="mcSvpChildSurveys"
                  ></ps-ui-multi-locale-field-label>
                </td>
              </ng-container>

              <ng-template #nonSvpBuyerSurvey>
                <ng-container *ngIf="survey.survey_grouping?.length">
                  <td>[{{ survey.survey_grouping }}]</td>
                </ng-container>
              </ng-template>
            </ng-container>

            <!-- Supplier -->
            <ng-container *psUiHasRole="'supplier'">
              <td
                *ngIf="
                  survey?.supplier_survey_grouping?.survey_ids?.length;
                  else none
                "
              >
                [{{ survey.supplier_survey_grouping?.survey_ids }}]
              </td>
            </ng-container>
            <!-- No grouping -->
            <ng-template #none>
              <td></td>
            </ng-template>
          </tr>
        </ng-container>
        <!-- Survey Live Entry Link - Operator -->
        <tr *psUiHasRole="'operator'">
          <td>Survey Live Entry Link</td>
          <td>
            <a
              target="_blank"
              href="{{
                survey.mc?.SVP && selectedSvpChildSurvey?.id
                  ? getBuyerTestEntryLink(selectedSvpChildSurvey.id)
                  : suppEntryLink
              }}"
              >{{
                survey.mc?.SVP && selectedSvpChildSurvey?.id
                  ? getBuyerTestEntryLink(selectedSvpChildSurvey.id)
                  : suppEntryLink
              }}</a
            >
          </td>
        </tr>
        <!-- Survey Test Entry Link - Buyer -->
        <tr *psUiHasRole="'buyer'">
          <td>Survey Test Entry Link</td>
          <td>
            <ng-container
              *ngIf="
                survey.mc?.SVP && selectedSvpChildSurvey?.id;
                else defaultLink
              "
            >
              <a
                href="{{ getBuyerTestEntryLink(selectedSvpChildSurvey.id) }}"
                target="_blank"
              >
                Test URL link
              </a>
            </ng-container>
            <ng-template #defaultLink>
              <a
                class="survey-link"
                target="_blank"
                href="{{ buyerTestEntryLink }}"
              >
                {{ buyerTestEntryLink }}
              </a>
            </ng-template>
          </td>
        </tr>
        <!-- Survey Live/Test Entry Link - Supplier -->
        <ng-container *psUiHasRole="'supplier'">
          <tr>
            <td>Survey Live Entry Link</td>
            <td>
              <a target="_blank" href="{{ survey.live_url }}">{{
                survey.live_url
              }}</a>
            </td>
          </tr>
          <tr>
            <td>Survey Test Entry Link</td>
            <td>
              <a
                class="survey-link"
                target="_blank"
                href="{{ survey.test_url }}"
                >{{ survey.test_url }}</a
              >
            </td>
          </tr>
        </ng-container>
        <!-- Redirect Urls - Supplier -->
        <ng-container *ngIf="survey.redirect_urls">
          <tr>
            <td>Complete Redirect</td>
            <td>{{ survey.redirect_urls.supp_url_completes }}</td>
          </tr>
          <tr>
            <td>Term Redirect</td>
            <td>{{ survey.redirect_urls.supp_url_terms }}</td>
          </tr>
          <tr>
            <td>Overquota Redirect</td>
            <td>{{ survey.redirect_urls.supp_url_overquota }}</td>
          </tr>
        </ng-container>
        <!-- Billing PO/Project Number -->
        <tr>
          <td>Billing PO/Project Number</td>
          <td style="display: flex">
            <div class="hover-edit-trigger row" title="click to edit">
              <div
                class="hover-text-field col-8"
                *ngIf="!isEditBillingNumber"
                (click)="enableEditBillingNumber()"
              >
                {{ survey.billing_id }}
                <div
                  class="pencil-outer pencil-outer-billing"
                  *psUiHasRole="'buyer'"
                >
                  <div class="fa fa-pencil"></div>
                </div>
              </div>
              <input
                class="inputText hover-font-color input-qbp-cpi col-8"
                type="inputText"
                placeholder="Billing number"
                [ngModel]="survey.billing_id"
                (ngModelChange)="onBillingNumberChange($event)"
                (keyup.enter)="updateBillingNumber()"
                *ngIf="isEditBillingNumber"
              />
              <div class="edit-button-group col-4" *ngIf="isEditBillingNumber">
                <div
                  class="fa fa-check glyphicon glyphicon-ok p-2 mx-2"
                  (click)="updateBillingNumber()"
                ></div>
                <div
                  class="fa fa-remove glyphicon glyphicon-remove p-2"
                  (click)="cancelBillingNumber()"
                ></div>
              </div>
            </div>
            <ps-ui-billing-number-tooltip
              *psUiHasRole="['buyer', 'operator']"
              [rules]="billingRules$ | async"
            ></ps-ui-billing-number-tooltip>
          </td>
        </tr>
        <!-- Billing External Id - Buyer -->
        <tr *psUiHasRole="'buyer'">
          <td>Billing External Id</td>
          <td>{{ survey.survey_external_id }}</td>
        </tr>
        <!-- Client - Operator/Buyer -->
        <tr *psUiHasRole="['buyer', 'operator']">
          <td>Client</td>
          <td>{{ survey.survey_client }}</td>
        </tr>
        <!-- Buyer Message -->
        <tr>
          <td>Buyer Message</td>
          <td>{{ survey.buyer_message }}</td>
        </tr>
        <!-- Force Block Creation - Operator -->
        <tr *psUiHasRole="'operator'">
          <td>Force Block Creation</td>
          <td>
            <a
              class="block-creation-btn"
              (click)="showModalBeforeBlockCreation()"
            >
              Create New Price Block
            </a>
          </td>
        </tr>
        <!-- Fusion Block Reset - Operator -->
        <tr *psUiHasRole="'operator'">
          <td>Fusion Block Reset</td>
          <td>
            <a
              class="reset-fusion-block-stats-btn"
              (click)="showModalBeforeResetFusionBlockStats()"
            >
              Reset Fusion Block Stats
            </a>
          </td>
        </tr>
        <!-- Lsr's OfferId - Operator -->
        <ng-container *ngIf="survey.offer_id">
          <tr *psUiHasRole="'operator'">
            <td>Lsr's OfferId</td>
            <td>{{ survey.offer_id }}</td>
          </tr>
        </ng-container>
        <!-- Lsr's TermId - Operator -->
        <ng-container *ngIf="survey.term_id">
          <tr *psUiHasRole="'operator'">
            <td>Lsr's TermId</td>
            <td>{{ survey.term_id }}</td>
          </tr>
        </ng-container>
        <!-- QLC - Operator/Buyer -->
        <ng-container *ngIf="survey.qlc">
          <tr>
            <td>QLC status</td>
            <td>{{ survey.qlc.enable ? 'Yes' : 'No' }}</td>
          </tr>
          <tr *ngIf="survey.qlc.enable">
            <td>Multiple Quota's</td>
            <td>{{ survey.qlc.multiple_quotas ? 'Yes' : 'No' }}</td>
          </tr>
          <tr *ngIf="survey.qlc.enable">
            <td>Completes are counted by</td>
            <td>
              {{
                survey.qlc.multiple_quotas.count_by_quota
                  ? 'Quota Complete'
                  : 'Survey Complete'
              }}
            </td>
          </tr>
          <tr *ngIf="survey.qlc.enable">
            <td>Supplier is compensated by</td>
            <td>
              {{
                survey.qlc.multiple_quotas.compensate_by_quota
                  ? 'Quota Complete'
                  : 'Survey Complete'
              }}
            </td>
          </tr>
        </ng-container>
        <!-- QBP status - Opeartor/Buyer -->
        <tr *psUiHasRole="['buyer', 'operator']">
          <td>QBP status</td>
          <td>{{ survey.is_qbp_enable ? 'Yes' : 'No' }}</td>
        </tr>
        <!-- CRM ID - Operator -->
        <tr *psUiHasRole="'operator'">
          <td>CRM ID</td>
          <td *ngIf="showCRMIdInput">
            <div class="row">
              <div class="col-md-6">
                <input
                  type="text"
                  class="form-control survey-data-input"
                  name="crmId"
                  [(ngModel)]="CRMId"
                  placeholder="Enter CRM ID"
                  (ngModelChange)="showCrmError = !CRMId"
                  (focus)="crmInputFocused = true"
                />
                <div *ngIf="showCrmError" class="err-msg">
                  <em
                    class="fa fa-exclamation-circle exclamationStyle"
                    aria-hidden="true"
                  ></em>
                  {{ EMPTY_CRMID_ERROR_TEXT }}
                </div>
              </div>
              <div *ngIf="crmInputFocused" class="col-md-1">
                <button
                  type="button"
                  class="btn btn-sm btn-primary save-button-2"
                  (click)="saveCRMId(CRMId)"
                >
                  Save
                </button>
              </div>
              <div *ngIf="crmInputFocused" class="col-md-1">
                <button
                  type="button"
                  class="btn btn-sm button-link"
                  (click)="enableEditCRMId(survey.crmId)"
                >
                  Cancel
                </button>
              </div>
            </div>
          </td>
          <td *ngIf="!showCRMIdInput" class="survey-data-edit-content">
            <ng-container>
              {{ survey.crmId }}
              <em
                *ngIf="survey.crmId"
                (click)="enableEditCRMId(survey.crmId)"
                class="fa fa-edit edit-icon"
              ></em>
            </ng-container>
          </td>
        </tr>
        <!-- ASANA ID -->
        <tr *psUiHasRole="'operator'">
          <td>ASANA ID</td>
          <td *ngIf="showASANAIdInput">
            <div class="row">
              <div class="col-md-6">
                <input
                  type="text"
                  class="form-control survey-data-input"
                  name="asanaId"
                  [(ngModel)]="ASANAId"
                  placeholder="Enter ASANA ID"
                  (ngModelChange)="showASANAError = !ASANAId"
                  (focus)="asanaInputFocused = true"
                />
                <div *ngIf="showASANAError" class="err-msg">
                  <em
                    class="fa fa-exclamation-circle exclamationStyle"
                    aria-hidden="true"
                  ></em>
                  {{ EMPTY_ASANAID_ERROR_TEXT }}
                </div>
              </div>
              <div *ngIf="asanaInputFocused" class="col-md-1">
                <button
                  type="button"
                  class="btn btn-sm btn-primary save-button-2"
                  (click)="saveASANAId(ASANAId)"
                >
                  Save
                </button>
              </div>
              <div *ngIf="asanaInputFocused" class="col-md-1">
                <button
                  type="button"
                  class="btn btn-sm button-link"
                  (click)="enableEditASANAId(survey.asanaId)"
                >
                  Cancel
                </button>
              </div>
            </div>
          </td>
          <td *ngIf="!showASANAIdInput" class="survey-data-edit-content">
            <ng-container>
              {{ survey.asanaId }}
              <em
                *ngIf="survey.asanaId"
                (click)="enableEditASANAId(survey.asanaId)"
                class="fa fa-edit edit-icon"
              ></em>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
